import React, { useEffect, useState } from "react";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import axiosInstance from "../../config/axios";

const ContactList = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPage, setTotalPage] = useState(null);
  const storeId = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const previousPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };
  const nestPage = () => {
    setPage(page + 1);
  };

  const invoiceDataList = () => {
    axiosInstance
      .get(
        `api/save-contact-from-apps-api/?store_id=${storeId}&page=${page}&search=${searchQuery}`,
        {
          headers: {
            Authorization: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        console.log(
          "invoice data list ====>",
          response?.data?.order_invoice_details,
        );
        setData(response?.data?.data);
        setTotalPage(response?.data?.total_pages);
        setCurrentPage(response?.data?.current_page);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    invoiceDataList();
  }, [page, searchQuery]);

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">Contact List</p>
        </div>
        <div className="p-2 pt-5">
          {/* <Button variant="outlined" color="primary" onClick={handleOpen}>
            <AddIcon />
            Add Product Specification
          </Button> */}
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              value={searchQuery}
              className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span></span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MOBILE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  App Name
                </TableCell>
                {/* <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-28">INVOICE NO.</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-28">ORDER ID</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">ORDER DATE</div>
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-28">ORDER STATUS</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-32">PAYMENT TYPE</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-36">PAYMENT</div>
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-36">TOTAL PRICE</div>
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-36"> TAX AMOUNT</div>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.name ? row?.name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.mobile ? row?.mobile : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.app_name ? row?.app_name : "--"}
                    </TableCell>
                    {/* <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.invoice_data?.invoice_no
                        ? row?.invoice_data?.invoice_no
                        : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.order_id ? row?.order_id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.order_date ? row?.order_date.slice(0, 10) : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <span>
                        {row?.order_status === "Delivered" ? (
                          <Button
                            className="!bg-green-400 !text-[8px] !text-white"
                            size="small"
                          >
                            Delivered
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Pending" ? (
                          <Button
                            className="!bg-pink-500 !text-[8px] !text-white"
                            size="small"
                          >
                            Pending
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Order Placed" ? (
                          <Button
                            className="!bg-yellow-400 !text-[8px] !text-white"
                            size="small"
                          >
                            Order Placed
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Shipped" ? (
                          <Button
                            className="!bg-purple-400 !text-[8px] !text-white"
                            size="small"
                          >
                            Shipped
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Drafts" ? (
                          <Button
                            className="!bg-red-600 !text-[8px] !text-white"
                            size="small"
                          >
                            Drafts
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Accepted" ? (
                          <Button
                            className="!bg-sky-300 !text-[8px] !text-white"
                            size="small"
                          >
                            Accepted
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Rejected" ? (
                          <Button
                            className="!bg-red-700 !text-[8px] !text-white"
                            size="small"
                          >
                            Rejected
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Assigned" ? (
                          <Button className="!bg-fuchsia-500 !text-[8px] !text-white">
                            Assigned
                          </Button>
                        ) : null}
                      </span>
                      <span>
                        {row?.order_status === "Cancelled" ? (
                          <Button className="!bg-red-500 !text-[8px] !text-white">
                            Cancelled
                          </Button>
                        ) : null}
                      </span>
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.invoice_data?.payment_type
                        ? row?.invoice_data?.payment_type
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.payment ? row?.payment : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      ₹ {row?.total_price ? row?.total_price : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      ₹ {row?.invoice_data?.total_tax_amount}
                    </TableCell> */}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            {currentPage}...{totalPage}
            <ArrowForwardIosIcon onClick={nestPage} />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon onClick={previousPage} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactList;
